import { configureCatalogStore } from '@state';
import { initQuerySync } from '@utils/search';
import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import AnimatedProvider from '@stone/components/routerTransitions/AnimatedProvider';
import AnimatedRoute from '@stone/components/routerTransitions/AnimatedRoute';
const Pdp = React.lazy(() => import('@stone/components/product/ProductPage'));
const Plp = React.lazy(() => import('@stone/components/listing/Plp'));
const store = configureCatalogStore();
initQuerySync(store);
const Catalog = (props) => {
    var _a;
    const locale = ((_a = document.documentElement.lang) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'en';
    const prefix = location.pathname.substr(0, location.pathname.indexOf(locale));
    const basePath = `${prefix}${locale}`;
    return (React.createElement(Provider, { store: store },
        React.createElement(BrowserRouter, { basename: basePath },
            React.createElement(AnimatedProvider, null,
                React.createElement(AnimatedRoute, { path: "/:path(.*)-:pid.html", key: "pdp" },
                    React.createElement(Suspense, { fallback: React.createElement("div", null) },
                        React.createElement(Pdp, Object.assign({}, props)))),
                React.createElement(AnimatedRoute, { path: "/:slug([^.]*)", key: "plp" },
                    React.createElement(Suspense, { fallback: React.createElement("div", null) },
                        React.createElement(Plp, Object.assign({}, props))))))));
};
// const Catalog: React.FC<Props> = (props) => {
//   // const locale = document.documentElement.lang?.toLowerCase() || 'en';
//   // const prefix = location.pathname.substr(0, location.pathname.indexOf(locale));
//   // const basePath = `${prefix}${locale}`;
//   return (
//     // <Provider store={store}>
//     //   <BrowserRouter basename={basePath}>
//     //     {/* <AnimatedProvider> */}
//     //     <Route path="/:path(.*)-:pid.html" key="pdp">
//     //       <Suspense fallback={<div></div>}>{/* <Pdp {...props} /> */}</Suspense>
//     //     </Route>
//     //     {/* tutto tranne path con punto, bisognerebbe riuscire a escludere solo i path con .html */}
//     //     <Route path="/:slug([\w\d\/-]*)" key="plp">
//     //       <Suspense fallback={<div></div>}>{/* <Plp {...props} /> */}</Suspense>
//     //     </Route>
//     //     {/* </AnimatedProvider> */}
//     //   </BrowserRouter>
//     // </Provider>
//     <>Test</>
//   );
// };
export default Catalog;
